// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"09cfd88f","137":"08644374","144":"dde1c0f2","256":"9b57649e","264":"80e3771c","304":"12a71983","402":"6f2b731e","407":"4703b206","453":"258b012d","581":"519c0b71","735":"de1be514","808":"e331f7d3"}[chunkId] + ".chunk.js";
};